import { IconButton } from '@recruit-robin/robin-theme/web-components';
import { Maximize_01 } from '@recruit-robin/robin-theme/web-icons';
import { useEffect, useState } from 'react';
import { useContextSelector } from 'use-context-selector';

import type { Candidate } from 'model/Candidate/Candidate';

import { Row } from 'components/ui/atoms/Row';
import { CandidateActionButtonsVariant } from 'components/ui/molecules/CandidateActionButtons/CandidateActionButtons.types';
import { CandidateActionButtons } from 'components/ui/molecules/CandidateActionButtons/CandidateActionButtonsLazy';
import { Modal } from 'components/ui/molecules/Modal';
import { usePageContext } from 'hooks/shared/usePageContext';
import { PageContext } from 'hooks/shared/usePageContext.types';
import { CandidateContextProvider } from 'shared/legacy/contexts/CandidateContext/CandidateContext';
import { SelectedCampaignContext } from 'shared/legacy/contexts/SelectedCampaignContext';
import { GlobalDialogType } from 'stores/global-dialogs/global-dialogs.store.types';
import { useGlobalDialogData } from 'stores/global-dialogs/hooks/useGlobalDialogData';
import { CandidateCVRender } from './CandidateCVRender';
import { useStyles } from './CandidateCVRender.styles';
import { useRequestCV } from './CandidateCVRender.useRequestCV';

export const CandidateCVRenderArea = ({ candidate }: { candidate: Candidate }) => {
  const classes = useStyles();
  const [visible, setVisible] = useState(false);
  const cv = useRequestCV(candidate);
  const pageContext = usePageContext();

  const selectedCandidate = useContextSelector(SelectedCampaignContext, (state) => state.selectedCandidate);
  const outreachMethod = useGlobalDialogData({ dialogType: GlobalDialogType.CandidateOutreach }, (s) => s.outreachType);
  const showExpandViewButton = pageContext === PageContext.Campaign || pageContext === PageContext.RatedCandidates;

  useEffect(() => {
    if (outreachMethod) {
      setVisible(false);
    }
  }, [outreachMethod]);

  useEffect(() => {
    if (visible && candidate.es_person_id !== selectedCandidate?.es_person_id) {
      setVisible(false);
    }
  }, [candidate, visible, selectedCandidate]);

  return (
    <Row css={classes.root} center contained>
      <CandidateCVRender candidate={candidate} cv={cv} />
      {showExpandViewButton && (
        <IconButton icon={<Maximize_01 size={14} />} onClick={() => setVisible(true)} style="bare" type="subtle" />
      )}

      <Modal visible={visible} onRequestClose={() => setVisible(false)} contentCss={classes.expandedCvViewModal}>
        <div css={classes.expandedCvViewWrapper}>
          <CandidateContextProvider candidate={candidate}>
            <CandidateActionButtons
              variant={CandidateActionButtonsVariant.candidateExpandedView}
              callback={() => setVisible(false)}
            />
            <CandidateCVRender candidate={candidate} cv={cv} />
          </CandidateContextProvider>
        </div>
      </Modal>
    </Row>
  );
};
